import { useEffect, useRef } from 'react';

// Hook
function useScrollToElement(isScrollingNeeded, onScrolled) {
  const focusingRef = useRef(null);
  useEffect(() => {
    if (isScrollingNeeded.value && focusingRef && focusingRef.current) {
      focusingRef.current.scrollIntoView(
        isScrollingNeeded.options || {
          behavior: 'smooth',
        },
      );
      if (onScrolled) onScrolled();
    }
  }, [isScrollingNeeded, onScrolled]);

  return focusingRef;
}

export default useScrollToElement;
